import { z } from 'zod'

export const UnsplashPhoto = z.object({
  id: z.string(),
  name: z.string(),
  author: z.string(),
  authorProfile: z.string(),
  alt: z.string(),
  type: z.enum(['photo']),
  tags: z.array(z.object({ type: z.enum(['search']), title: z.string() })),
  thumbnail: z.string(),
  downloadLink: z.string(),
  source: z.string(),
})

export type UnsplashPhoto = z.infer<typeof UnsplashPhoto>;